import axios from 'axios';
import { firebaseAuth } from '@/lib/firebase';

/**
 * Código de erro de domínio do backend (`{ error: 'ACCOUNT_NOT_FOUND', ... }`).
 * Reexportado daqui porque este é o ponto que o resto do app já conhece — a
 * implementação mora em `@react-apps/auth`, compartilhada com o admin-dashboard.
 */
export { extractApiErrorCode } from '@react-apps/auth';

const BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
const SCOPE_ID = import.meta.env.VITE_SCOPE_ID as string;

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'x-scope-id': SCOPE_ID,
  },
});

apiClient.interceptors.request.use(async (config) => {
  const user = firebaseAuth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});
